module.exports = "/_next/static/images/e5-1-0917a4651390e7a775912e5526fef113.png.webp";